import { contactDeleteDialogErrorDescription } from '../../strings.locstring.json';
import { cancelLabel } from 'owa-locstrings/lib/strings/cancellabel.locstring.json';
import { somethingWentWrongLabel } from 'owa-locstrings/lib/strings/somethingwentwronglabel.locstring.json';
import loc from 'owa-localize';
import { deletePersona as owsDeletePersona } from '../../dataLayer/ows/persona/deletePersona';
import { invalidateLpcCachedContacts, unfavoriteDeletedPersonas } from '../utils/hubPersonasUtils';
import {
    createDataActionFactory,
    addNotification,
    Feature,
    createThunk,
    HubPersona,
    PersonType,
    ThunkDispatch,
    getLogSafeId,
} from '../../../shared';

export interface DeletePersonaInfo {
    deletedHubPersonaId: string;
    deletedPersonCount?: number;
    deletedPdlCount?: number;
}

export const deletePublicFolderPersonaCompletedAction = createDataActionFactory<
    DeletePersonaInfo,
    DeletePersonaInfo
>('DeletePublicFolderPersonaCompletedAction', Feature.ContactManagement, action => {
    if (!action.payload.deletedHubPersonaId) {
        return null;
    }

    return {
        count: 1,
        pdl: action.payload.deletedPdlCount,
        person: action.payload.deletedPersonCount,
    };
});

const logSafePersonaId = (personaId: string) => {
    return getLogSafeId(personaId) + '_' + personaId.length;
};

const getDeletedPersonaStats = (deletedPersona: HubPersona) => {
    const deletedPdlCount = deletedPersona.type === PersonType.PrivateDistributionList ? 1 : 0;
    const deletedPersonCount = deletedPersona.type === PersonType.Person ? 1 : 0;

    return { deletedPdlCount, deletedPersonCount };
};

/**
 * Deletes a given persona. Used when deleting a persona in a Public Folder.
 * @param deletedPersona The persona to delete
 * @param currentFolderId The folder id of the current (public) folder
 */
export const deletePublicFolderPersona = (deletedPersona: HubPersona, currentFolderId: string) =>
    createThunk('DeletePublicFolderPersona', (dispatch: ThunkDispatch, getState: () => {}) => {
        if (
            deletedPersona.type !== PersonType.Person &&
            deletedPersona.type !== PersonType.PrivateDistributionList
        ) {
            return;
        }

        const deletedPersonaId = deletedPersona.personaId;
        const deletedHubPersonaId = deletedPersona.hubPersonaId;

        owsDeletePersona(
            deletedPersonaId,
            currentFolderId,
            logSafePersonaId(deletedPersonaId)
        ).then(
            response => {
                invalidateLpcCachedContacts(dispatch, [deletedPersona]);
                unfavoriteDeletedPersonas(dispatch, getState, [deletedPersona]);

                // The postDelete operations rely on the personas still being in the store,
                // We are dispatching the deleteComplete action now.
                dispatch(
                    deletePublicFolderPersonaCompletedAction.success({
                        deletedHubPersonaId,
                        ...getDeletedPersonaStats(deletedPersona),
                    })
                );
            },
            () => {
                dispatch(deletePublicFolderPersonaCompletedAction.error({ deletedHubPersonaId }));

                addNotification(
                    loc(somethingWentWrongLabel),
                    loc(contactDeleteDialogErrorDescription),
                    loc(cancelLabel)
                );
            }
        );
    });
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
